export default __webpack_public_path__ + "static/media/homeHero.0e9acd85.jpg";